(async () => {
  if (!customElements.get('featured-products-slider')) {
    const { default: Swiper, A11y, Navigation, Autoplay, Grid } = await import('swiper');

    Swiper.use([A11y, Navigation, Autoplay, Grid]);

    class featuredProductsSlider extends HTMLElement {
      constructor() {
        super();

        this.slider = this;
        this.swiperElement = this.slider.querySelector('[data-swiper]');
        this.loader = this.slider.querySelector('[data-loader]');
        this.productsWrapper = this.slider.querySelector('[data-featured-products-slider-content]');
        this.collectionLinks = this.slider.querySelectorAll('[data-featured-products-slider-link]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 16,
          threshold: 10,
          breakpoints: {
            320: {
              slidesPerView: 1.2,
            },
            480: {
              slidesPerView: 2.2,
            },
            768: {
              slidesPerView: 3.2,
            },
            1024: {
              slidesPerView: 3.2,
            },
            1280: {
              slidesPerView: 4.2,
            },
          },
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        /**
         * Listen to extra events when in Shopify editor
         */
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });
        }

        // Only do it once, not on every web component render.
        window.onload = () => {
          this.swiperInstance.updateSlides();
          this.swiperInstance.updateSize();
          if (this.swiperOptions.navigation) {
            this.swiperInstance.navigation.init();
            this.swiperInstance.navigation.update();
          }
        };

        window.addEventListener('resize', () => {
          // check if it should be displayed in a grid on mobile
          if (screen.width <= 1023) {
            if (this.swiperOptions.breakpoints[320].grid) {
              if (this.swiperOptions.breakpoints[320].grid.rows === 2) {
                this.swiperElement.classList.add('swiper-grid');
              } else {
                this.swiperElement.classList.remove('swiper-grid');
              }
            }
          }

          // check if it should be displayed in a grid on desktop
          if (screen.width >= 1024) {
            if (this.swiperOptions.breakpoints[1024].grid) {
              if (this.swiperOptions.breakpoints[1024].grid.rows === 2) {
                this.swiperElement.classList.add('swiper-grid');
              } else {
                this.swiperElement.classList.remove('swiper-grid');
              }
            }
          }
          this.swiperInstance.updateSlides();
          this.swiperInstance.update();
          if (this.swiperOptions.navigation) {
            this.swiperInstance.navigation.init();
            this.swiperInstance.navigation.update();
          }
        });

        // catch click on collection links
        if (this.collectionLinks && this.productsWrapper) {
          this.collectionLinks.forEach((link) =>
            link.addEventListener('click', this.loadProducts.bind(this))
          );
        }
      }

      loadProducts(event) {
        event.preventDefault();
        const url = event.target.href;

        // Get current slider height to prevent CLS
        var height = this.swiperElement.offsetHeight;
        // show loader
        this.loader?.classList.remove('hidden');

        // destroy the swiper
        this.swiperElement.style.height = height + `px`;
        this.productsWrapper.classList.add('opacity-0');
        this.slider.swiperInstance.destroy(false);

        // update the classes
        this.querySelector('.featured-products-slider__nav-item--active').classList.remove(
          'featured-products-slider__nav-item--active'
        );
        event.target.classList.add('featured-products-slider__nav-item--active');
        // check if it should be displayed in a grid on mobile
        if (screen.width <= 1023) {
          if (this.swiperOptions.breakpoints[320].grid) {
            if (this.swiperOptions.breakpoints[320].grid.rows === 2) {
              this.swiperElement.classList.add('swiper-grid');
            } else {
              this.swiperElement.classList.remove('swiper-grid');
            }
          }
        }

        // check if it should be displayed in a grid on desktop
        if (screen.width >= 1024) {
          if (this.swiperOptions.breakpoints[1024].grid) {
            if (this.swiperOptions.breakpoints[1024].grid.rows === 2) {
              this.swiperElement.classList.add('swiper-grid');
            } else {
              this.swiperElement.classList.remove('swiper-grid');
            }
          }
        }

        // get the new content
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('#products');
            this.productsWrapper.innerHTML = parsedHTML.innerHTML;
          })
          .then(() => {
            // update swiper on new content and show the slider
            this.swiperInstance.updateSlides();
            this.swiperInstance.updateSize();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          })
          .then(() => {
            // update slider nav
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            // hide loader and show slider
            this.loader?.classList.add('hidden');
            this.swiperElement.style.height = 'auto';
            this.productsWrapper.classList.remove('opacity-0');
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }

    window.featuredProductsSlider = featuredProductsSlider;
    customElements.define('featured-products-slider', featuredProductsSlider);
  }
})();
